<div class="modal-body">{{ message | translate }}</div>
